<template>
    <div>
        <h1>{{ $t("admin.adminCreditRequestList.header") }}</h1>
        <div v-if="selected">
            <form @submit="resolve">
                <label for="creditCountGranted">{{ $t("admin.adminCreditRequestList.creditsGranted") }}: </label><input id="creditCountGranted" name="creditCountGranted" v-model="selected.creditCountGranted"><br/>

                <input type="submit" class="submit" value="Resolve">
            </form>
        </div>
        <table class="datatable">
            <caption class="caption">Credit request list table</caption>
            <tr>
                <th scope="col">{{ $t("admin.adminCreditRequestList.table.timestamp") }}</th>
                <th scope="col">Plan</th>
                <th scope="col">{{ $t("admin.adminCreditRequestList.table.user") }}</th>
                <th scope="col">{{ $t("admin.adminCreditRequestList.table.request") }}</th>
                <th scope="col">{{ $t("admin.adminCreditRequestList.table.message") }}</th>
            </tr>
            <tr v-for="(cr, index) in listing" v-bind:key="index">
                <td style="vertical-align: top; cursor: pointer;" v-on:click="selectRow(cr)">{{ new Date(cr.createdTimestamp).toLocaleString() }}</td>
                <td style="vertical-align: top;"><router-link :to="'/admin/planView/' + cr.planId">{{ cr.planName }}</router-link></td>
                <td style="vertical-align: top;"><router-link :to="'/admin/userView/' + cr.requestedAppUserId">{{cr.requestedAppUserEmailAddress}}</router-link></td>
                <td style="vertical-align: top;">{{cr.creditCountRequested}}</td>
                <td style="vertical-align: top;">{{cr.message}}</td>
            </tr>
        </table>
    </div>
</template>

<script>
    import { adminService } from '@/services/admin.service'

    export default {
        name: 'AdminCreditRequestList',
        data: function() {
            return {
                listing: [],
                selected: null
            };
        },
        created: function() {
            this.fetchData();
        },
        methods: {
            fetchData: function () {
                adminService.creditRequestList().then((data) => {
                    this.listing = data;
                }).catch((err) => {
                    console.error('Unable to list credit request: ', err)
                });
            },
            selectRow: function(r) {
                this.selected = r;
            },
            resolve: function(event) {
                event.preventDefault();

                this.selected.status = this.selected.creditCountGranted === 0 ? 2 : 1;
                adminService.creditRequestResolve(this.selected.id, this.selected).then(() => {
                    this.selected = null;
                    this.fetchData();
                }).catch((err) => {
                    console.error('Unable to resolve credit request: ', err)
                });
            }
        }
    }
</script>
